import { API_URL } from '../constant'
import queryString from 'query-string'

import { saveAs } from 'file-saver';
var FileSaver = require('file-saver');

/**
 * Global loader event dispatcher
 * Dispatches custom events to show/hide the global loader
 * skipLoader option can be set to true to exclude form submissions
 */
const dispatchLoaderEvent = (show) => {
  window.dispatchEvent(new CustomEvent(show ? 'loader:show' : 'loader:hide'));
};

/**
 * Main API request function
 * @param {Object} options - Request options
 * @param {Object} options.data - Request body data
 * @param {Object} options.query - URL query parameters
 * @param {string} options.method - HTTP method (GET, POST, PUT, DELETE)
 * @param {string} options.endpoint - API endpoint path
 * @param {string} options.baseurl - Custom base URL (optional)
 * @param {Object} options.headers - Custom headers (optional)
 * @param {boolean} options.skipLoader - Skip showing loader (for form submissions)
 */
export function api({
  data,
  query = {},
  method = 'GET',
  endpoint = '',
  baseurl = false,
  headers,
  skipLoader = false, // Set to true to skip loader (e.g., for form submissions)
}) {
  // Show loader unless explicitly skipped
  if (!skipLoader) {
    dispatchLoaderEvent(true);
  }

  localStorage.getItem('token')
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')

  if (localStorage.getItem('token') && !headers?.apikey) {
    const userInfo = localStorage.getItem('userInfo') || '{}'
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`)
  }

  for (const key in headers) {
    myHeaders.append(key, headers[key])
  }
  for (let key in data) {
    if (data[key] === undefined || data[key] === null || data[key] === '') {
      delete data[key]
    }
  }
  const rawBody = JSON.stringify(data)

  var requestOptions = {
    method,
    headers: myHeaders,
    body: rawBody,
  }

  return fetch(
    `${baseurl || API_URL}${endpoint}?${queryString.stringify(query, {
      arrayFormat: 'bracket',
    })}`,
    requestOptions,
  )
    .then(CheckError)
    .finally(() => {
      // Hide loader after request completes (success or error)
      if (!skipLoader) {
        dispatchLoaderEvent(false);
      }
    });
}

function serialize(obj) {
  const str = []
  for (var p in obj)
    if (obj.prototype.hasOwnProperty.call(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
    }
  return str.join('&')
}

export function fileUpload(file, path) {
  return new Promise((resolve, reject) => {
    const data = new FormData()
    console.log(file);
    data.append('image', file)

    const xhr = new XMLHttpRequest()
    // xhr.withCredentials = true

    xhr.addEventListener('readystatechange', function () {
      if (this.readyState === 4) {
        resolve(JSON.parse(this.responseText))
      }
    })

    xhr.open('POST', API_URL + path)
    if (localStorage.getItem('token')) {
      xhr.setRequestHeader(
        'Authorization',
        `Bearer ${localStorage.getItem('token')}`,
      )
    }
    xhr.send(data)
  })
}

async function CheckError(response) {
  if (response.status >= 200 && response.status <= 299) {
    return response.json();
  } else {
    throw new Error((await response.json()).message);
  }
}

export function downloadFile({ data, query = {}, method = 'GET', endpoint = '', baseurl = false, headers }) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  if (localStorage.getItem('token') && !headers?.apikey) {
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
  }

  for (const key in headers) {
    myHeaders.append(key, headers[key]);
  }
  for (let key in data) {
    if (data[key] === undefined || data[key] === null || data[key] === '') {
      delete data[key];
    }
  }
  const rawBody = JSON.stringify(data);

  var requestOptions = {
    method,
    headers: myHeaders,
    body: rawBody,
  };

  window.open(`${baseurl || API_URL}${endpoint}?${queryString.stringify({ ...query, token: localStorage.getItem('token') }, {
    arrayFormat: 'bracket',
  })}`, '_parent');
}